import BlogCarousel from 'Src/js/components/carousels/BlogCarousel.vue';
import Vue from "vue";
import { PostQuery } from "JS/services/BlogService";

export function initializeBlogCarousel(selector: string, props: {
	title: string;
	smallTitle?: string;
	viewAllLink: string,
	viewAllLinkAssistiveText: string,
	query: PostQuery
}): void {

	if (props.smallTitle == null) {
		props.smallTitle = props.title;
	}

	const blogCarousel: HTMLElement | undefined = document.querySelector(selector);
	if (blogCarousel) {
		new Vue({
			el: blogCarousel,
			render: h => h(BlogCarousel, {
				props,
			}),
		});
	}
}